export const PAGINATION_ROW_COUNT_SIZES: ReadonlyArray<number> = [20, 50, 100];
